import { MonthlyProductType } from '../../../../license/types/MonthlyProductType';
import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

export enum LicenseProductStatus {
  NO_PRODUCTS = 0,
  ACTIVE = 1,
  EXPIRED = 2,
  INVALID = 3,
  TRIAL = 4,
}

export namespace LicenseProductStatus {
  // `status in LicenseStatus` forces the object to contain _all statuses_ as keys, otherwise it won't compile
  const statusToClass: { [status in LicenseProductStatus]: string } = {
    [LicenseProductStatus.NO_PRODUCTS]: '-',
    [LicenseProductStatus.ACTIVE]: 'bullet-success',
    [LicenseProductStatus.EXPIRED]: 'bullet-danger',
    [LicenseProductStatus.INVALID]: 'bullet-danger',
    [LicenseProductStatus.TRIAL]: 'bullet-warning',
  };

  export function getBulletStatusClass(status: LicenseProductStatus) {
    return statusToClass[status];
  }
}

export interface LicenseUsage {
  productId: LicenseProductIdEnum;
  productType?: MonthlyProductType;
  productStatus?: LicenseProductStatus;
  licenseKey?: string;
  totalSeats?: number;
  reservedSeats?: number;
  usedReservedSeats?: number,
  availableReservedSeats?: number,
  unreservedSeats?: number,
  usedUnreservedSeats?: number,
  availableUnreservedSeats?: number;
  minimalCommitment?: number | null;
  subscriptionEndDate?: number | null;
  hasInheritedSubscriptionEndDate?: boolean;
  autoRenewal?: string;
  isInheriting?: boolean;
  hasBasicMonthly?: boolean;
  expiryDate?: number;
  isMonthly?: boolean;
  isAddon?: boolean;
  lastCheckedTimestamp?: number;
  hasMspTrial?: boolean;
  isTrial?: boolean;
  isInProductTrial?: boolean;

  usageBreakdown?: {
    entities: {
      total: number;
      used: number;
    };
    servers?: {
      total: number;
      used: number;
    };
    mailboxes?: {
      total: number;
      used: number;
    };
    mobiles?: {
      total: number;
      used: number;
    };
  };

  protectionModel?: number;
}

export namespace License {
  export function isValid(license: LicenseUsage) {
    return (
      license.productStatus !== LicenseProductStatus.INVALID && license.productStatus !== LicenseProductStatus.EXPIRED
    );
  }
}
